<mat-expansion-panel [hideToggle]="false"
                     [togglePosition]="'before'"
                     (opened)="onOpened()"
                     (closed)="onClosed()"
>
    <mat-expansion-panel-header>
    <div class="card-header">
      <div class="card-title">
        <ng-content select="[card-title]"></ng-content>
      </div>
      <div class="card-actions">
        <ng-content select="[card-actions]"></ng-content>
      </div>
      <div class="card-status">
        <ng-content select="[card-status]"></ng-content>
      </div>
    </div>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <section class="card-content">
        <!-- LAZY mode with trpLazyCardContent -->
        <ng-container *ngIf="lazyCardContent; else legacyContent">
            <ng-container *ngIf="expanded">
                <ng-container
                        *ngTemplateOutlet="lazyCardContent.templateRef"
                ></ng-container>
            </ng-container>
        </ng-container>

        <!-- LEGACY static Mode -->
        <ng-template #legacyContent>
            <ng-container *ngIf="expanded">
                <ng-content select="[card-content]"></ng-content>
            </ng-container>
        </ng-template>
    </section>
  </ng-template>
</mat-expansion-panel>
